import * as R from "ramda";

const maintenanceData = (state: any) => R.pathOr([], ["myhealth", "result"], state);
const cautionsData = (state: any) => R.pathOr([], ["myhealth", "cautionsData"], state);
const componentTrackingData = (state: any) => R.pathOr([], ["myhealth"], state);
const componentTrackingfilter = (state: any) =>  R.pathOr([], ["myhealth"], state); 
const selectedMRData = (state: any) => R.pathOr([], ["myhealth"], state);
const selectors = {
  maintenanceData,
  cautionsData,
  componentTrackingData,
    componentTrackingfilter,
    selectedMRData
};

export default selectors;
